// extracted by css-extract-rspack-plugin
export default {"cards":"zO2um","card":"LmbqV","description":"Bq4z8","img":"kYyHe","separator":"AEjug","left":"Pfsne","tabletPlus":"GYARQ","mobile":"Q8XoE"};